/*! Albatross (C) GrandPad, Inc */

import * as root_html from './root.html';
import Vue from 'vue';

// Shared components used throughout the login flow
import('../shared/components/design-system/gp-button');
import('../shared/components/design-system/gp-formgroup');

interface LoginConfig
{
	email: string | null;
}

export let LoginVueRoot = new Vue({

	render: root_html.render,
	staticRenderFns: root_html.staticRenderFns,

	data: function ()
	{
		return {
			config: <any>null as LoginConfig
		};
	},

	components: {
		'gpal-login': () => import('./login')
	},

	watch: {},

	methods: {},

	created: function ()
	{
		console.log('LoginVueRoot created');
		const domRoot = document.getElementById('gpal-app-root') as HTMLDivElement;
		this.config = JSON.parse(domRoot.dataset.config as string) as LoginConfig;
	},

	mounted: function ()
	{
		console.log('LoginVueRoot mounted');
	},

	updated: function ()
	{
		console.log('LoginVueRoot updated');
	},

	destroyed: function ()
	{
		console.log('LoginVueRoot destroyed');
	}
});
